import { PayloadAction, createSlice } from '@reduxjs/toolkit'

export interface ItemList {
  companyDatabaseId: number,
  companyName: string,
  tenants: string,
  databaseName: string,
  driversCount: number,
  isActive: boolean
}

export interface DataInfo {
  pageNumber?: number,
  pageSize?: number,
  totalPages?: number,
  totalResults?: number,
  itemList: ItemList[]
}

export interface CompaniesFilters {
  currentPage: number,
  pageSize: number,
  orderByColumn: string,
  ascending: boolean,
  companyId?: number,
}

export interface FolhadePontoDetailsState {
  filters: CompaniesFilters,
  loading: boolean,
  data: DataInfo,
  error: string | undefined,
}

const initialState: FolhadePontoDetailsState = {
  filters: {
    orderByColumn: 'CompanyName',
    currentPage: 1,
    pageSize: 15,
    ascending: true,
  },
  data: {
    itemList: [
      {
        companyDatabaseId: 0,
        companyName: '',
        tenants: '',
        databaseName: '',
        driversCount: 0,
        isActive: true
      }
    ],
    totalResults: 0,
    totalPages: 0,
    pageNumber: 0,
    pageSize: 0
  },
  loading: true,
  error: ''
}

export const backofficeCompaniesSlice = createSlice({
  name: 'backofficeCompanies',
  initialState,
  reducers: {
    changeFilters: (state, action: PayloadAction<CompaniesFilters>) => {
      state.filters.pageSize = action.payload.pageSize
      state.filters.currentPage = action.payload.currentPage
      state.filters.ascending = action.payload.ascending
      state.filters.companyId = action.payload.companyId
      state.filters.orderByColumn = action.payload.orderByColumn
    },
    handleItemList: (state, action: PayloadAction<DataInfo>) => {
      state.data.itemList = action.payload.itemList
    }
  }
})

export const { changeFilters, handleItemList } = backofficeCompaniesSlice.actions